export const SET_AUTH = 'SET_AUTH';
export const SET_REPORTING_RIGHTS = 'SET_REPORTING_RIGHTS';
export const SET_MARVIN_AUTH = 'SET_MARVIN_AUTH';
export const SET_V1_REPORT_CONTEXT = 'SET_V1_REPORT_CONTEXT';
export const SET_STATUS_ERROR_CODE = 'SET_STATUS_ERROR_CODE';
